import React from 'react';
import t from "../../../../../helpers/t";
import {moment} from "../../../../../../../vendor";
import {Biscuit} from "../../../../../../utils";
import {rbac} from "../../../index";

const UserWebView = (props) => {
    const {user, index, deleteUserPending,editUserPending, onDeleteUser, onRestoreUser, currentUrl, rights, onChangeUserActive} = props;
    const role = Biscuit.get('user.role');
    return (
        <>
            <div className={"inb-c-item inb-c-item--order" + ((user.active === true) ? ' not-marked' : ' red-marked') + ((user.deleted !== null) ? ' removed': '')} key={index}>
                <div className="large-2 medium-8 small-8 column show-label" title={t('kunden_nbr',null,'capital')} >
                    <span>{user.customer_nbr}</span>
                </div>
                <div className="large-2 medium-8 small-8 column show-label" title={t('name',null,'capital')} >
                    <span>{user.first_name + ' ' + user.last_name}</span>
                </div>
                <div className="large-2 medium-8 small-8 column show-label" title={t('username',null,'capital')} >
                    <span>{user.username}</span>
                </div>
                <div className="large-2 medium-8 small-8 column inb-user--email show-label" title={t('email',null,'capital')} >
                    {user.email}<br/>
                    {user.verified === 'pending'?'('+t('verification pending',null,'capital')+')':''}
                </div>
                <div className="large-1 medium-8 small-8 column show-label" title={t('created',null,'capital')} data-label="Erstellt am: ">
                    <span>{moment(user.created).format('DD.MM.YYYY')}</span>
                </div>
                <div className="large-1 medium-8 small-8 column show-label" title={t('user_active',null,'capital')}>
                    { editUserPending !== user.id && (rights[role] >= rights[user.role]) ? <> <div className="switch tiny inb-form__controllClass">
                                <input id={"user_item_input_active_"+index} type="checkbox" disabled={user.deleted !== null} className="user_item_input_active switch-input" checked={user.active} onChange={(e) => onChangeUserActive(e,user)} />
                                <label className={"no-label switch-paddle switch-paddle-" + Biscuit.get('user.client_id')} htmlFor={"user_item_input_active_"+index}>
                                    <span className="show-for-sr">Toggle content</span>
                                </label>
                            </div></>:<><div className="switch tiny inb-form__controllClass show-label">
                                <input id={"user_item_input_active_"+index} type="checkbox" disabled={user.deleted !== null} className="user_item_input_active switch-input" checked={user.active} />
                                <label className={"no-label switch-paddle switch-paddle-" + Biscuit.get('user.client_id')} htmlFor={"user_item_input_active_"+index}>
                                    <span className="show-for-sr">Toggle content</span>
                                </label>
                            </div></>}
                    {editUserPending === user.id &&  <>
                        <span><img alt="RollingLoader" className="rollingLoader colorize-black" src={"assets/img/rolling_loader.svg"} /> </span>
                    </>}
                        </div>
                <div className="show-for-large column large-1">
                <div className="large-12 medium-offset-0 medium-8 item-button-group column ">
                    
                    <div className="button-container">
                        { rbac.hasPermission('editUser') && (rights[role] >= rights[user.role]) &&
                            <a
                                href={"/users/"+user.id+currentUrl.search}
                                title={t('edit')}
                                data-inb-action-link="edit">
                                <button type="button" className="inb-round-btn hollow round float-left">
                                    <div className="inb-fi-edit"></div>
                                </button>
                            </a>
                        }
                    </div>
                    <div className="button-container">
                        { rbac.hasPermission('delete') && (rights[role] >= rights[user.role]) && <>
                            { deleteUserPending !== index ? <>
                                {user.deleted === null ? <>
                                    <a
                                        href="#"
                                        className="inb-reservation__pdf2"
                                        title={t('delete')}>
                                        <button type="button" className="inb-round-btn hollow round float-left"
                                                onClick={() => onDeleteUser(user, index)}>
                                            <div className="inb-fi-remove"></div>
                                        </button>
                                    </a></>
                                :
                                    <>
                                        <a
                                            href="#"
                                            className="inb-reservation__pdf2"
                                            title={t('restore')}>
                                            <button type="button" className="inb-round-btn hollow round float-left"
                                                    onClick={() => onRestoreUser(user, index)}>
                                                <div className="fi fi-refresh"></div>
                                            </button>
                                        </a>
                                    </>
                            }
                            </>: <>
                                <span><img alt="RollingLoader" className="rollingLoader colorize-black" src={"assets/img/rolling_loader.svg"} /> </span>
                            </>}</>
                        }
                    </div>
                </div>
                </div>
                <div className="show-for-large column large-1">
                    <div className="large-12 medium-offset-0 medium-8 item-button-group btn-grp-2 column " >
                        { user.active &&
                            <div className="button-container">
                                <a
                                    href={"/orders/add?user_id=" + user.id + "&skipFilter=1"}
                                    title={t('add_${a}',{a:t('order')})}>
                                    <button type="button" className="inb-round-btn hollow round float-left">
                                        <div className="inb-fi-page-add"></div>
                                    </button>
                                </a>
                            </div>
                        }
                        <div className="button-container">
                            <a
                                href={"/reservations/reservationsList?user_id=" + user.id + "&fullname=" + user.first_name + " " + user.last_name}
                                title={t('orders',null,'capital')}>
                                <button type="button" className="inb-round-btn hollow round float-left">
                                    <div className="inb-fi-page"></div>
                                </button>
                            </a>
                        </div>
                    </div>


                </div>

                <div className="hide-for-large hide-for-medium" style={{width:"100%"}}>
                    <div className="large-1 medium-offset-0 medium-8 item-button-group column " style={{marginRight: "5%", float: "left", display: "block"}}>

                        <div className="button-container">
                            { rbac.hasPermission('editUser') && (rights[role] >= rights[user.role]) &&
                                <a
                                    href={"/users/"+user.id+currentUrl.search}
                                    title={t('edit')}
                                    data-inb-action-link="edit">
                                    <button type="button" className="inb-round-btn hollow round float-left">
                                        <div className="inb-fi-edit"></div>
                                    </button>
                                </a>
                            }
                        </div>
                        <div className="button-container">
                            { rbac.hasPermission('delete') && (rights[role] >= rights[user.role]) && <>
                                { deleteUserPending !== index ? <>
                                    <a
                                        href="#"
                                        className="inb-reservation__pdf2"
                                        title={t('delete')}>
                                        <button type="button" className="inb-round-btn hollow round float-left" onClick={ () => onDeleteUser(user,index)}>
                                            <div className="inb-fi-remove"></div>
                                        </button>
                                    </a>
                                </>: <>
                                    <span><img alt="RollingLoader" className="rollingLoader colorize-black" src={"assets/img/rolling_loader.svg"} /> </span>
                                </>}</>
                            }
                        </div>
                    </div>

                    <div className="large-1 medium-offset-0 medium-8 item-button-group btn-grp-2 column " style={{marginRight: "5%", float: "left", display: "block"}}>
                        { user.active &&
                            <div className="button-container">
                                <a
                                    href={"/orders/add?user_id=" + user.id + "&skipFilter=1"}
                                    title={t('add_${a}',{a:t('order')})}>
                                    <button type="button" className="inb-round-btn hollow round float-left">
                                        <div className="inb-fi-page-add"></div>
                                    </button>
                                </a>
                            </div>
                        }
                        <div className="button-container">
                            <a
                                href={"/reservations/reservationsList?user_id=" + user.id + "&fullname=" + user.first_name + " " + user.last_name}
                                title={t('orders',null,'capital')}>
                                <button type="button" className="inb-round-btn hollow round float-left">
                                    <div className="inb-fi-page"></div>
                                </button>
                            </a>
                        </div>
                    </div>


                </div>


                <div className="hide-for-large hide-for-small">
                    <div className="large-1 medium-offset-0 item-button-group column" style={{marginRight: "5%", float: "left", display: "block"}}>

                        <div className="button-container">
                            { rbac.hasPermission('editUser') && (rights[role] >= rights[user.role]) &&
                                <a
                                    href={"/users/"+user.id+currentUrl.search}
                                    title={t('edit')}
                                    data-inb-action-link="edit">
                                    <button type="button" className="inb-round-btn hollow round float-left">
                                        <div className="inb-fi-edit"></div>
                                    </button>
                                </a>
                            }
                        </div>
                        <div className="button-container">
                            { rbac.hasPermission('delete') && (rights[role] >= rights[user.role]) && <>
                                { deleteUserPending !== index ? <>
                                    <a
                                        href="#"
                                        className="inb-reservation__pdf2"
                                        title={t('delete')}>
                                        <button type="button" className="inb-round-btn hollow round float-left" onClick={ () => onDeleteUser(user,index)}>
                                            <div className="inb-fi-remove"></div>
                                        </button>
                                    </a>
                                </>: <>
                                    <span><img alt="RollingLoader" className="rollingLoader colorize-black" src={"assets/img/rolling_loader.svg"} /> </span>
                                </>}</>
                            }
                        </div>
                    </div>

                    <div className="large-1 medium-offset-0 item-button-group btn-grp-2 column " style={{marginRight: "5%", float: "left", display: "block"}} >
                        { user.active &&
                            <div className="button-container">
                                <a
                                    href={"/orders/add?user_id=" + user.id + "&skipFilter=1"}
                                    title={t('add_${a}',{a:t('order')})}>
                                    <button type="button" className="inb-round-btn hollow round float-left">
                                        <div className="inb-fi-page-add"></div>
                                    </button>
                                </a>
                            </div>
                        }
                        <div className="button-container">
                            <a
                                href={"/reservations/reservationsList?user_id=" + user.id + "&fullname=" + user.first_name + " " + user.last_name}
                                title={t('orders',null,'capital')}>
                                <button type="button" className="inb-round-btn hollow round float-left">
                                    <div className="inb-fi-page"></div>
                                </button>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default UserWebView;